import { isMobile } from 'react-device-detect';

const fontSizes = {
	xs: isMobile ? '12px' : '14px',
	sm: isMobile ? '14px' : '16px',
	md: isMobile ? '16px' : '20px',
	lg: isMobile ? '20px' : '24px',
	xl: isMobile ? '22px' : '30px',
	xl2: isMobile ? '24px' : '36px',
	xl3: isMobile ? '26px' : '42px',
	xl4: isMobile ? '28px' : '48px',
	xl5: isMobile ? '30px' : '54px',
};

export default fontSizes;
